var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVstarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 110,
    viewBox: "0 0 156 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_1128",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 0,
    width: 103,
    height: 110
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.608 11.6761L92.946 37.7996L117.407 53.5476H87.3949L72.387 94.8651C71.5643 96.9021 70.7415 99.8682 69.922 101.721C69.2444 103.329 68.0311 104.709 66.4486 105.672C64.8661 106.634 62.9918 107.132 61.0831 107.096C59.5479 107.084 58.0381 106.741 56.6794 106.097C55.3207 105.452 54.1524 104.525 53.2719 103.391C54.4463 105.256 56.1508 106.806 58.2102 107.881C60.2695 108.955 62.6092 109.516 64.9888 109.505H91.0956C93.7877 109.509 96.4197 108.788 98.654 107.434C100.888 106.081 102.623 104.156 103.635 101.908L135.293 15.3779C138.376 7.03942 145.365 0.183955 155.439 0.183955H121.313C117.236 0.0201395 113.21 1.05066 109.838 3.12127C106.465 5.19188 103.928 8.19122 102.604 11.6703",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_1128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.647 0.00201416H53.2719V109.502H155.647V0.00201416Z",
    fill: "url(#paint0_linear_2_1128)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2624 11.6759L62.924 37.7994L38.4627 53.5474H68.4751L83.483 94.8649C84.3057 96.902 85.1285 99.868 85.948 101.72C86.6252 103.329 87.8384 104.71 89.421 105.672C91.0037 106.635 92.8781 107.132 94.7869 107.096C96.3221 107.083 97.8319 106.741 99.1906 106.097C100.549 105.452 101.718 104.525 102.598 103.391C101.424 105.256 99.7192 106.806 97.6598 107.88C95.6005 108.955 93.2608 109.516 90.8813 109.505H64.7872C62.1722 109.518 59.6103 108.84 57.4177 107.556C55.2251 106.271 53.4979 104.436 52.4493 102.277C52.2444 101.908 52.2444 101.72 52.0395 101.351L20.5897 15.1989C17.5068 6.86036 10.5183 0.00489494 0.443695 0.00489494H34.5698C38.6568 -0.0824156 42.6694 1.00023 46.0308 3.09723C49.3923 5.19423 51.9297 8.19764 53.2784 11.6759",
    fill: "#E3000F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_1128",
    x1: 62.6904,
    y1: 91.763,
    x2: 150.648,
    y2: 23.4532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A71511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#E3000F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3000F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVstarLogo);
export default __webpack_public_path__ + "static/media/vstarLogo.ec09f6d5324315da24add0ee879a0dd6.svg";
export { ForwardRef as ReactComponent };